{
  "title": "Our Products",
  "subtitle": "Browse our catalog and place your order.",
  "search_placeholder": "Search for a product...",
  "filter_brand": "Brand",
  "filter_category": "Category",
  "categories": {
    "all": "All products",
    "dairy": "Dairy",
    "sauce": "Sauces",
    "food": "Canned goods",
    "cleaning": "Cleaning",
    "rice": "Rice & Grains",
    "drink": "Drinks"
  },
  "in_stock": "In stock",
  "out_of_stock": "Out of stock",
  "unit": "Unit",
  "min_order": "Min. order",
  "price_from": "From",
  "no_results": "No products found",
  "featured": "Popular products",
  "promotions": "Current promotions",
  "brand_page_title": "{{brand}} Products",
  "delivery_available": "Delivery available in the Dakar region",
  "product_detail": "Product detail",
  "description": "Description",
  "related_products": "You may also like",
  "back_to_catalog": "Back to catalog",
  "brand_products": "{{brand}} Products",
  "sku": "SKU",
  "weight": "Weight",
  "min_qty": "Minimum quantity",
  "add_to_cart": "Add to cart",
  "added_to_cart": "Added to cart",
  "low_stock": "Low stock",
  "next_slide": "Next slide",
  "our_brands": "Our Brands",
  "prev_slide": "Previous slide",
  "recently_viewed": "Recently Viewed"
}
